import React from 'react';
import '../../ElectricFuelPages/ElectricFuel.scss';

interface OfficeData {
  s_no: number;
  office_city: string;
  hub_name?: string;
  gst_no?: string;
  vendor_code?: string;
  vendor_company?: string;
  status: number;
  vendor_name?: string;
  address_one?: string;
  address_two?: string;
  pan_no?: string;
  state_name?: string;
}

const VendorsView = ({ office }: { office: OfficeData }) => {
  const statusBadge = () => {
    if (office.status === 5)
      return <span className="tag is-success is-light">Active</span>;
    return <span className="tag is-danger is-light">Inactive</span>;
  };

  const fields = [
    { label: 'Company', value: office.vendor_company, icon: 'fa fa-building' },
    { label: 'Name', value: office.vendor_name, icon: 'fa fa-user' },
    { label: 'Code', value: office.vendor_code, icon: 'fa fa-barcode' },
    { label: 'GST No.', value: office.gst_no, icon: 'fa fa-file-text' },
    { label: 'PAN No.', value: office.pan_no, icon: 'fa fa-id-card' },
    { label: 'State', value: office.state_name, icon: 'fa fa-map-marker' },
    {
      label: 'Address',
      value: [office.address_one, office.address_two].filter(Boolean).join(', '),
      icon: 'fa fa-home',
    },
  ];

  return (
    <div className="p-4">
      <div className="detail-view-avatar">
        <i className="fa fa-truck"></i>
      </div>
      <div className="columns is-multiline">
        {fields.map((field, idx) => (
          <div className="column is-6" key={idx}>
            <div className="detail-view-field">
              <p className="detail-view-label">
                <i className={`${field.icon} mr-1`}></i> {field.label}
              </p>
              <p className="detail-view-value">{field.value || '—'}</p>
            </div>
          </div>
        ))}
        <div className="column is-6">
          <div className="detail-view-field">
            <p className="detail-view-label">
              <i className="fa fa-toggle-on mr-1"></i> Status
            </p>
            <p className="detail-view-value">{statusBadge()}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VendorsView;
